import styled, { css } from 'styled-components'

export const styles = css`
  display: inline-block;
  vertical-align: middle;
  width: 100%;
  height: 40px;
  color: ${props => props.theme.form.fontColor};
  font-size: 16px;
  line-height: 1;
  margin: 0;
  padding: 12px;
  border-color: ${props => props.theme.form.passiveColor};
  border: 1px solid ${props => props.theme.form.passiveColor};
  border-radius: ${props => props.theme.form.borderRadius};
  background: ${props => props.theme.form.inputBackgroundColor};
  box-sizing: border-box;
  box-shadow: ${props => props.theme.form.innerBoxShadow};
  transition: border-color 300ms ease, color 300ms ease;

  &:focus {
    box-shadow: 0 0 7px rgba(0, 0, 0, 0.3);
    outline: 0;
  }

  &[disabled] {
    cursor: not-allowed;
    background-color: ${props => props.theme.form.inputDisabledBackgroundColor};
    color: ${props => props.theme.form.passiveColor};
  }

  &[readonly] {
    background-color: ${props => props.theme.form.inputDisabledBackgroundColor};
    border-color: ${props => props.theme.form.passiveColor};
  }

  ::-webkit-input-placeholder {
    color: ${props => props.theme.form.placeholderColor};
  }

  ::-moz-placeholder {
    color: ${props => props.theme.form.placeholderColor};
  }

  :-ms-input-placeholder {
    color: ${props => props.theme.form.placeholderColor};
  }

  :-moz-placeholder {
    color: ${props => props.theme.form.placeholderColor};
  }
`

export const StyledInput = styled.input.attrs({
  className: 'form-input'
})`
  ${styles}
`
